import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import styles from '../../css/app.css';
import ClassNames from 'classnames';
import GestureHelper from 'gesture-helper';
// import GestureHelper from '../../../../../gesture-helper/dist/';
// import GestureHelper from '../../../../../gesture-helper/src/gesture-helper';
import TweenLite from 'gsap/TweenLite';
import CSSPlugin from 'gsap/CSSPlugin';

const PanelComponents = {
  Ordinary: require('../panels/panel.stateless.jsx').default,
  // Ordinary: require('../panels/panel.jsx').default,
  Lighting: require('../panels/ghost-lighting.jsx').default,
  Hologram: require('../panels/ghost-hologram.jsx').default,
  Smoke: require('../panels/ghost-smoke.jsx').default,
  RubAway: require('../panels/ghost-rub-away.jsx').default,
  DeletingText: require('../panels/ghost-deleting-text.jsx').default,
  EndPage: require('../panels/ghost-end-page.jsx').default,
};

import appEvents from '../../utils-and-data/events.js';

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPanels: [],
      currentIndex: 0,
      atStart: true,
    };

    this.PANEL_CHANGE_THRESHOLD = 0.33;
    this.TRANSLATE_RATIO = 0.7;
    this.SLIDE_CHANGE_DURATION = 0.3;

    this.panelRefs = {};
    this.currentRange = [-1,0,1];
  }

  setLighting = (ev) => {
    this.setState({ lightsMode: ev.mode });
  }

  componentDidMount() {
    appEvents.on('setLighting', this.setLighting);
    this.gestureControl = new GestureHelper(this.containerRef, {
      onPanStart: this.onPanStart,
      onPan: this.onPan,
      onPanEnd: this.onPanEnd,
      sensitivity: 0,
      swipeVelocity: 0.8,
      passive: false,
      capture: false,
      allowOppositeDirection: false,
    });
    window.addEventListener('keydown', this.onKeyDown, false);

    // Some router logic to restore previous carousel sessions:
    if (history.state
      && history.state.panel !== this.currentRange[1]) {

      let newIndex = history.state.panel;
      this.currentRange = [
        newIndex - 1, newIndex, newIndex + 1
      ];
      this.setState({
        currentIndex: newIndex,
        atStart: newIndex === 0,
        atEnd: newIndex === this.props.panels.length - 1,
      });
    }

    // Setup paging for our initial carousel position:
    this.rePage({direction: 0});
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('carousel did update!', prevProps, this.props);

    // New panel content may have been recieved
    // If so, do a check and update text inside state:
    let shouldUpdate = false;
    for (var i = 0; i < this.state.currentPanels.length; i++) {
      let panel = this.state.currentPanels[i];
      if ((!panel.paragraphs
        && panel.page_number
        && this.props.panels[panel.page_number - 1].paragraphs)
          || this.shouldUpdatePanel(panel, this.props.panels[panel.page_number - 1])) {

        shouldUpdate = true;
        break;
      }
    }

    // Update panels text content:
    if (shouldUpdate) {
      let newPanels = this.state.currentPanels;
      for (var i = 0; i < newPanels.length; i++) {
        let item = this.props.panels[newPanels[i].page_number - 1];
        if (item) {

          // Update paragraphs of this panel, and the ghost text if it exists:
          newPanels[i].paragraphs = item.paragraphs;
          if (item.ghost) newPanels[i].ghost = item.ghost;
        }
      }
      this.setState({ currentPanels: newPanels });
    }
  }

  componentWillUnmount() {

    // @TODO: Unbind all listeners (resize, gestures, keydown):
    appEvents.removeListener('setLighting', this.setLighting);
    this.gestureControl && this.gestureControl.destroy();
  }

  onKeyDown = (e) => {

    // Throttle key navigation, to happen one at a time,
    // and for only the left && right arrow keys:
    if (this.currentlyPaging
      || (e.keyCode !== 37 && e.keyCode !== 39)
      || this.state.locked) return;

    this.currentlyPaging = true;
    this.switchedDirection = true;
    switch (e.keyCode) {
      case 37:
        this.direction = -1;
        this.prevPanel();
        break;
      case 39:
        this.direction = 1;
        this.nextPanel();
        break;
    }
  }

  onPanStart = () => {
    this.containerRef.style.cursor = '-webkit-grabbing';
    this.containerRef.style.cursor = '-moz-grabbing';
    this.containerRef.style.cursor = 'grabbing';
    this.direction = null;
  }

  onPan = (e) => {
    let ratio;
    let x = e.deltaX;

    // Apply translate dempening if they're at either edge
    // of the carousel (and trying to go further)
    if ((this.state.currentIndex === 0 && x > 0)
      || (this.atEnd && x < 0)) {

      ratio = 0.2;
    } else {
      ratio = this.TRANSLATE_RATIO;
    }

    this.transX = x * ratio;
    this.setState({ ghostTransX: this.transX });
    let newDirection = this.transX < 0 ? 1 : -1;
    if (newDirection !== this.direction) {
      this.switchedDirection = true;
      this.direction = newDirection;
    } else {
      this.switchedDirection = false;
    }
    this.drawFrame();
  }

  onPanEnd = (e) => {
    this.containerRef.style.cursor = null;
    let reset = true;
    if (e.isSwipe && !this.state.locked && !this.currentlyPaging) {
      if (e.swipeDirection === 'right') {
        this.nextPanel();
      } else {
        this.prevPanel();
      }
      reset = false;
    } else if (this.transX > 0
      && this.transX >= this.props.dimensions.width * this.PANEL_CHANGE_THRESHOLD
      && !this.state.locked
      && !this.currentlyPaging) {

      this.prevPanel();
      reset = false;
    } else if (this.transX < 0
      && this.transX <= this.props.dimensions.width * this.PANEL_CHANGE_THRESHOLD * -1
      && !this.state.locked
      && !this.currentlyPaging) {

      this.nextPanel();
      reset = false;
    }

    reset && this.reset();
  }

  nextPanel() {
    if (this.state.currentIndex === this.props.panels.length - 1) {

      // At the end, cant move fwd
      this.reset();
    } else {
      this.setState({ currentIndex: this.state.currentIndex + 1 });
      TweenLite.to(this.getAnimatables(), this.SLIDE_CHANGE_DURATION, {
        x: 0 - this.props.dimensions.width,
        ease: Quart.easeInOut,
        onUpdate: this.onTweenUpdate,
        onUpdateParams: ['{self}'],
        roundProps: 'x',
        onComplete: () => this.rePage({direction:1})
      });
    }
  }

  prevPanel() {
    if (this.state.currentIndex === 0) {

      // At the start, cant move back
      this.reset();
    } else {
      this.setState({ currentIndex: this.state.currentIndex - 1 });
      TweenLite.to(this.getAnimatables(), this.SLIDE_CHANGE_DURATION, {
        x: this.props.dimensions.width,
        ease: Quart.easeInOut,
        onUpdate: this.onTweenUpdate,
        onUpdateParams: ['{self}'],
        roundProps: 'x',
        onComplete: () => this.rePage({ direction: -1 })
      });
    }
  }

  rePage({direction=0} = {}) {

    // Change our range to update it's new bounds:
    for (var i = 0; i < this.currentRange.length; i++) {
      this.currentRange[i] += direction;
    }

    // Update content / ordering of all the CurrentPanels:
    let newPanels = [];

    // Starting state:
    if (direction === 0) {
      newPanels = this.resetCurrentPanels();
      for (var i = 0; i < this.currentRange.length; i++) {
        if (this.props.panels[this.currentRange[i]]) {
          newPanels[i] = {
            ...newPanels[i],
            ...this.props.panels[this.currentRange[i]]
          };
        }
      }

    // Step back one panel:
    } else if (direction < 0) {

      // So:
      // 1 - load a new "prev" panel
      // 2 - change the old "prev" panel to "curr"
      // 3 - change the "curr" panel to "next" and
      // 4 - Splice the "next" panel,
      for (var i = 0; i < this.state.currentPanels.length; i++) {
        let panel = this.state.currentPanels[i];
        if (panel.order === 'prev') {
          panel.order = 'curr';
          newPanels.push(panel);
        } else if (panel.order === 'curr') {
          panel.order = 'next';
          newPanels.push(panel);
        }
      }
      let newPrev = this.props.panels[this.currentRange[0]];
      if (newPrev) {
        newPrev.order = 'prev';
        newPanels.push(newPrev);
        this.atEnd = false;
      }

    // Step fwd one panel:
    } else if (direction > 0) {

      // So:
      // 1 - load a new "next" panel
      // 2 - change the "curr" panel to "prev"
      // 3 - change the "next" panel to "curr" and
      // 4 - Splice the "prev" panel,
      for (var i = 0; i < this.state.currentPanels.length; i++) {
        let panel = this.state.currentPanels[i];
        if (panel.order === 'next') {
          panel.order = 'curr';
          newPanels.push(panel);
        } else if (panel.order === 'curr') {
          panel.order = 'prev';
          newPanels.push(panel);
        }
      }
      let newNext = this.props.panels[this.currentRange[2]];
      if (newNext) {
        newNext.order = 'next';
        newPanels.push(newNext);
        this.atEnd = false;
      } else {
        this.atEnd = true;
      }
    }

    this.setState({ currentPanels: newPanels }, () => {
      this.reset({ duration: 0 })
        .then(() => {
          if (direction !== 0) this.slideCallback();
        });
    });
  }

  reset = ({duration=this.SLIDE_CHANGE_DURATION} = {}) => {
    let complete = res => {
      this.setState({ ghostTransX: 0 });
      setTimeout(() => { this.currentlyPaging = false }, 5);
      //           5ms = the init time for all ghost FX  ^
      res();
    }

    return new Promise((res,rej) => {
      let targets = this.getAnimatables();
      if (duration !== 0) {
        TweenLite.to(targets, duration, {
          x: 0,
          ease: Quart.easeInOut,
          onUpdate: this.onTweenUpdate,
          onUpdateParams: ['{self}'],
          roundProps: 'x',
          onComplete: () => complete(res)
        });
      } else {
        TweenLite.set(targets, {
          x: 0,
          onComplete: () => complete(res),
        })
      }
    });
  }

  slideCallback() {
    if (this.oldIndex !== this.state.currentIndex
      || this.oldIndex === 'undefined') {

      // console.log('slide callback!');
      this.oldIndex = this.state.currentIndex;
      if (this.oldIndex === 0) {
        this.setState({ atStart: true });
      } else if (this.oldIndex === this.props.panels.length - 1) {
        this.setState({ atEnd: true });
      } else {
        this.setState({ atStart: false, atEnd: false });
      }
      if (typeof this.props.slideCallback === 'function') {
        this.props.slideCallback(this.state.currentIndex);
      }
    }
  }

  drawFrame() {
    // console.log('draw frame!');
    TweenLite.set(this.getAnimatables(), { x: this.transX });
  }

  storeRef(type, el) {
    // console.log('store a ref:', el);
    if (el !== null) this[type] = el;
  }

  // As the carousel moves, this function allows
  // the WebGL layer to move with it
  onTweenUpdate = (tween) => {
    this.currentlyPaging = true;
    let target = tween.target[0] ? tween.target[0] : tween.target;
    if (target._gsTransform) {
      // appEvents.emit('translateX', target._gsTransform.x);
      this.setState({ ghostTransX: target._gsTransform.x });
    }
  }

  setCarouselLock = (boolean) => {
    this.setState({ locked: boolean });
    console.log('SET carousel lock', this.state.locked);
  }

  render() {
    return (
      <div styleName='carousel'
        className={ClassNames({
          'lights-out': this.state.lightsMode === 'dark',
          'locked': this.state.locked
        })}>

        <div ref={c => this.storeRef('containerRef', c)}
          className='panels-container'>

          {this.state.currentPanels.map((item,i) => {
            if (!item.page_number) return null;
            let type = item.ghost ? item.ghost.effect : 'Ordinary';
            const Panel = PanelComponents[type];
            return <Panel paragraphs={item.paragraphs}
              slices={this.props.slices}
              setCarouselLock={this.setCarouselLock}
              key={item.page_number}
              pageNumber={item.page_number}
              order={item.order}
              ghost={item.ghost}
              voiceLayer={this.props.voiceLayer}
              dimensions={this.props.dimensions}
              currentIndex={this.state.currentIndex}
              ghostTransX={this.state.ghostTransX}
              ghostPreTransX={this.state.ghostPreTransX}
              resetCarousel={this.reset} />
          })}
        </div>
        <footer className={ClassNames({
            'at-start': this.state.atStart,
            'at-end': this.state.atEnd,
          })}>

          <button className='prev'
            onClick={e => this.onKeyDown({keyCode: 37})}>. . .</button>
          <span className='page-number'>
            {this.state.currentIndex + 1} / {this.props.panels.length}
          </span>
          <button className='next'
            onClick={e => this.onKeyDown({keyCode: 39})}>. . .</button>
        </footer>
      </div>
    );
  }


  // HELPERS
  // --------------------------------------------
  getAnimatables() {
    return this.containerRef.children;

    /*
    // due to the dom lookups of classNames, this helper could be slightly expensive.
    // to keep things light, introduce some light caching of the dom refs returned,
    if (this.switchedDirection) {

      // always animate *only* the current panel, and
      // the next one toward our current gesture direction
      let toAnimate = this.containerRef.children;
      // let picker = this.direction < 0 ? 'prev' : 'next';
      // for (var i = 0; i < this.containerRef.children.length; i++) {
      //   // let child = this.containerRef.children[i];
      //   // if (child.classList.contains('curr')
      //   //   || child.classList.contains(picker)) {

      //     this.containerRef.children[i].classList.add('sliding');
      //     // toAnimate.push(child);
      //   // }
      // }

      this.oldAnimatables = toAnimate;
      // console.log('NEW animatables');
      return toAnimate;
    } else if (this.oldAnimatables) {
      // console.log('CACHED animatables');
      return this.oldAnimatables;
    } else {
      // console.log('ALL children');
      return this.containerRef.children;
    }*/
  }

  resetCurrentPanels() {
    return [
      { order: 'prev', },
      { order: 'curr', },
      { order: 'next', }
    ];
  }

  shouldUpdatePanel(oldPage, newPage) {
    let shouldUpdate = false;
    if (oldPage.paragraphs) {

      // First, check regular text:
      let oldText = oldPage.paragraphs.join('');
      let newText = newPage.paragraphs.join('');
      if (oldText !== newText) {
        shouldUpdate = true;

      // Second, check ghost text:
      } else if (oldPage.ghost) {
        let oldGhost = oldPage.ghost.paragraphs.join('');
        let newGhost = newPage.ghost.paragraphs.join('');
        shouldUpdate = oldGhost !== newGhost;
      }
    }
    return shouldUpdate;
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(Carousel, styles);






// WEBPACK FOOTER //
// ./app/frontend/components/partials/carousel.jsx